import outlet from "fragments/news/outlet"
import gql from "graphql-tag"

const SEARCH_OUTLETS = gql`
  ${outlet}

  query searchOutlets($searchOutletsInput: SearchOutletsInput!) {
    searchOutlets(searchOutletsInput: $searchOutletsInput) {
      ...Outlet
    }
  }
`

export default SEARCH_OUTLETS
